import { render, staticRenderFns } from "./YourFavorite.vue?vue&type=template&id=28ecc63a&scoped=true&lang=pug&"
import script from "./YourFavorite.vue?vue&type=script&lang=js&"
export * from "./YourFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ecc63a",
  null
  
)

export default component.exports